import React, { useState } from "react";
import toast from "react-hot-toast";

import { Eye16Filled, EyeOff16Filled } from "@fluentui/react-icons";
import { Input, Button, Spinner, Text, Field } from "@fluentui/react-components";

import { UpdatePassword } from "./components/update-password";
import { useSettingsStyles } from "./styles";

import { updateUserKey } from "@/services/user-service";
import { useAuth } from "@/context/auth";

export const Settings = () => {
  const [openAIKey, setOpenAIKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { user } = useAuth();
  const styles = useSettingsStyles();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await updateUserKey(user?.user.id, openAIKey);
      setOpenAIKey("");
      setError(null);
      toast.success("OpenAI key updated successfully");
    } catch (error) {
      setError(error?.message || "Failed to update OpenAI key");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <Text weight="semibold" size={500}>
        Settings
      </Text>
      <form onSubmit={handleSubmit} className={styles.form} autoComplete="off">
        <div className={styles.fieldContainer}>
          <Field label="OpenAI API Key">
            <Input
              id="openai-key"
              data-lpignore="true"
              placeholder="Enter your OpenAI API key"
              type={passwordVisible ? "text" : "password"}
              value={openAIKey}
              onChange={(e) => setOpenAIKey(e.target.value)}
              contentAfter={
                <Button
                  icon={passwordVisible ? <Eye16Filled /> : <EyeOff16Filled />}
                  onClick={() => setPasswordVisible(!passwordVisible)}
                  appearance="transparent"
                />
              }
              required
              className={styles.input}
            />
          </Field>
        </div>
        {error && (
          <div>
            <Text className={styles.errorText}>{error}</Text>
          </div>
        )}
        <Button type="submit" appearance="primary" disabled={isLoading}>
          {isLoading ? <Spinner size="extra-tiny" label="Saving..." /> : "Save"}
        </Button>
      </form>
      <UpdatePassword />
    </div>
  );
};
